/*
 * @Author: zhangjingqing
 * @Date: 2022-02-10 22:54:32
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-24 20:27:47
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\router\router.config.js
 */
import {
	UserLayout,
	BasicLayout,
	TaxLayout,
	RouteView,
	// AppLayout,
} from "@/layouts";

export const appMap = [{
	path: "/",
	name: "taxRiskControl",
	redirect: "/taxRiskControl",
},
	{
		path: "/taxRiskControl",
		name: "taxRiskControl",
		component: TaxLayout,
		redirect: "/taxRiskControl/dataCollect",
		hidden: true,
		children: [{
			path: "/taxRiskControl/dataCollect",
			name: "dataCollect",
			meta: {
				title: "数据采集"
			},
			component: () =>
				import(
					/* webpackChunkName: "user" */
					"@/views/taxRiskControl/dataCollect/Index"
					),
		},
			{
				path: "/taxRiskControl/riskAnalyse",
				name: "riskAnalyse",
				meta: {
					title: "风险检测"
				},
				component: () =>
					import(
						/* webpackChunkName: "user" */
						"@/views/taxRiskControl/riskAnalyse/Index"
						),
			},
			{
				path: "/taxRiskControl/reportAnalyse",
				name: "reportAnalyse",
				meta: {
					title: "申报检测"
				},
				component: () =>
					import(
						/* webpackChunkName: "user" */
						"@/views/taxRiskControl/reportAnalyse/Index"
						),
			},
		],
	},
	{
		path: "/taxRiskControl/riskAnalyse/report",
		name: "riskReport",
		meta: {
			title: "检测报告"
		},
		component: () =>
			import(
				/* webpackChunkName: "user" */
				"@/views/taxRiskControl/riskAnalyse/RiskReport"
				),
	},


	{
		path: "/taxRiskControl/riskAnalyse/reportBasis",
		name: "riskReportBasis",
		meta: {
			title: "检测报告2"
		},
		component: () =>
			import(
				"@/views/taxRiskControl/riskAnalyse/RiskReportBasis"
				),
	},
	{
		path: "/taxRiskControl/riskAnalyse/pdfBasis",
		name: "riskPdfBasis",
		meta: {
			title: "检测报告pdf2"
		},
		component: () =>
			import(
				"@/views/taxRiskControl/riskAnalyse/RiskPdfBasis"
				),
	},
	{
		path: "/taxRiskControl/riskAnalyse/pdf",
		name: "riskPdf",
		meta: {
			title: "检测报告pdf"
		},
		component: () =>
			import(
				/* webpackChunkName: "user" */
				"@/views/taxRiskControl/riskAnalyse/RiskPdf"
				),
	},
	{
		path: "/taxRiskControl/riskMobileAnalyse/report",
		name: "riskMobileReport",
		meta: {
			title: "检测报告"
		},
		component: () =>
			import(
				/* webpackChunkName: "user" */
				"@/views/taxRiskControl/riskMobileAnalyse/RiskReport"
				),
	},
	{
		path: "/taxRiskControl/riskMobileAnalyse/pdf",
		name: "riskMobilePdf",
		meta: {
			title: "检测报告pdf"
		},
		component: () =>
			import(
				/* webpackChunkName: "user" */
				"@/views/taxRiskControl/riskMobileAnalyse/RiskPdf"
				),
	},
	{
		path: "/taxRiskControl/griskAnalyse/pdf",
		name: "riskPdf",
		meta: {
			title: "检测报告pdf"
		},
		component: () =>
			import(
				/* webpackChunkName: "user" */
				"@/views/taxRiskControl/griskAnalyse/RiskPdf"
				),
	},
	{
		path: "*",
		redirect: "/404",
		hidden: true,
	},
	// {
	// 	path: "/taxationAi/index",
	// 	name: "taxationAi",
	// 	meta: {
	// 		title: "税务AI助手"
	// 	},
	// 	component: () =>
	// 		import(
	// 			/* webpackChunkName: "user" */
	// 			"@/views/user/taxationAi"
	// 		),
	// },
];

export const adminMap = [{
	path: "/",
	name: "dashboard",
	component: BasicLayout,
	redirect: "/dashboard",
	children: [{
		path: "/dashboard",
		name: "dashboard",
		meta: {
			title: "首页",
			icon: "home"
		},
		component: () => import("@/views/Dashboard"),
	},
		{
			path: "/userManage",
			name: "userManage",
			meta: {
				title: "人员管理",
				icon: "team"
			},
			component: RouteView,
			redirect: "/userManage/user",
			children: [{
				path: "/userManage/user",
				name: "user",
				meta: {
					title: "用户管理"
				},
				component: () => import("@/views/userManage/user/Index"),
			}, ],
		},
		{
			path: "/tenantManagement",
			name: "tenantManagement",
			meta: {
				title: "租户信息管理",
				icon: "database"
			},
			component: RouteView,
			redirect: "/tenantManagement/tenant",
			children: [{
				path: "/tenantManagement/tenant",
				name: "tenant",
				meta: {
					title: "租户管理"
				},
				component: () => import("@/views/tenantManagement/tenant/Index"),
			},
				{
					path: "/tenantManagement/fields",
					name: "fields",
					meta: {
						title: "扩展字段管理"
					},
					component: () => import("@/views/tenantManagement/fields/Index"),
				},
			],
		},
		{
			path: "/cataManage",
			name: "cataManage",
			meta: {
				title: "目录树管理",
				icon: "apartment"
			},
			component: () => import("@/views/cataManage/Index"),
		},
		{
			path: "/dataTableManage",
			name: "dataTableManage",
			meta: {
				title: "数据表管理",
				icon: "file-text"
			},
			component: () => import("@/views/dataTableManage/Index"),
		},
		{
			path: "/riskAnalyseRule",
			name: "riskAnalyseRule",
			meta: {
				title: "风险分析指标管理",
				icon: "bar-chart"
			},
			component: () => import("@/views/riskAnalyseRule/Index"),
		},
		{
			path: "/combRiskIndex",
			name: "combRiskIndex",
			meta: {
				title: "组合风险指标管理",
				icon: "deployment-unit"
			},
			component: () => import("@/views/combRiskIndex/Index"),
		},
		{
			path: "/templateManage",
			name: "templateManage",
			meta: {
				title: "Excel模板管理",
				icon: "file-excel"
			},
			component: () => import("@/views/templateManage/Index"),
		},
		{
			path: "/subjectManage",
			name: "subjectManage",
			meta: {
				title: "标准科目管理",
				icon: "file-excel"
			},
			component: () => import("@/views/subjectManage/Index"),
		},
		{
			path: "/softwareMap",
			name: "softwareMap",
			meta: {
				title: "财务软件模版维护",
				icon: "file-excel"
			},
			component: () => import("@/views/softwareMap/Index"),
		},
	],
},
	{
		path: "*",
		redirect: "/404",
		hidden: true,
	},
];



export const constantRouterMap = [{
	path: "/user",
	component: UserLayout,
	redirect: "/user/login",
	hidden: true,
	children: [{
		path: "login",
		name: "login",
		meta: {
			title: "税务风控"
		},
		component: () =>
			import( /* webpackChunkName: "user" */ "@/views/user/Login"),
	},
		// {
		//   path: "register",
		//   name: "register",
		//   component: () =>
		//     import(/* webpackChunkName: "user" */ "@/views/user/Register"),
		// },
	],
},
	{
		path: "/taxationAi",
		component: UserLayout,
		redirect: "/taxationAi/index",
		hidden: true,
		children: [{
			path: "index",
			name: "taxationAi",
			meta: {
				title: "税务AI助手"
			},
			component: () => import("@/views/user/taxationAi")
		}]
	},
	{
		path: "/tenantManagement",
		name: "tenantManagement",
		meta: {
			title: "租户信息管理",
			icon: "database"
		},
		component: RouteView,
		redirect: "/tenantManagement/tenant",
		children: [{
			path: "/tenantManagement/tenant",
			name: "tenant",
			meta: {
				title: "租户管理"
			},
			component: () => import("@/views/tenantManagement/tenant/Index"),
		},
			{
				path: "/tenantManagement/fields",
				name: "fields",
				meta: {
					title: "扩展字段管理"
				},
				component: () => import("@/views/tenantManagement/fields/Index"),
			},
		],
	},
	{
		path: "/404",
		component: () =>
			import( /* webpackChunkName: "fail" */ "@/views/exception/404"),
	},
];



export const admin3Map = [{
	path: "/",
	name: "dashboard",
	component: BasicLayout,
	redirect: "/dashboard",
	children: [{
		path: "/dashboard",
		name: "dashboard",
		meta: {
			title: "首页",
			icon: "home"
		},
		component: () => import("@/views/Dashboard"),
	},
		{
			path: "/userManage",
			name: "userManage",
			meta: {
				title: "人员管理",
				icon: "team"
			},
			component: RouteView,
			redirect: "/userManage/user",
			children: [{
				path: "/userManage/user",
				name: "user",
				meta: {
					title: "用户管理"
				},
				component: () => import("@/views/userManage/user/Index"),
			}, ],
		},
		{
			path: "/userManage",
			name: "userManage",
			meta: {
				title: "人员画像",
				icon: "team"
			},
			component: RouteView,
			redirect: "/userManage/user",
		},
		{
			path: "/userManage",
			name: "userManage",
			meta: {
				title: "使用情况查询",
				icon: "team"
			},
			component: RouteView,
			redirect: "/userManage/user",
		},
	],
},
	{
		path: "*",
		redirect: "/404",
		hidden: true,
	},
];
